function PropertiesEmpty() {
  return (
    <div className="text-center">
      <div className="text-gray-400 mb-2">
        <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
        </svg>
      </div>
      <h3 className="text-sm font-medium text-gray-700 mb-1">No Object Selected</h3>
      <p className="text-xs text-gray-500">Select an object to view its properties</p>
    </div>
  );
}

export default PropertiesEmpty;
